export default {
    getBeneficiaries(state) {
        return state.beneficiaries;
    },
    getBeneficiaryAge(state) {
        var d = new Date(state.beneficiary.dateOfBirth);
        var birthYear = d.getFullYear();
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var age = currentYear - birthYear;
        return age;
    },
    getBeneficiaryAdvancedSearchCount(state) {
        return state.beneficiaryAdvancedSearchCount;
    },
    getBeneficiaryAdvancedSearchResults(state) {
        return state.advancedSearchResults;
    },
    getCreatedBeneficiaries(state) {
        return state.createdBeneficiaries;
    },
    getBeneficiaryHistory(state) {
        return state.beneficiaryHistory;
    }
};